import React, { useEffect } from 'react';
import { ThemeProvider, Toaster, useToast } from '@elva/ui';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '@/data/queryClient';
import { registerToastNotifier } from '@/data/toastBridge';

function ToastBridgeWirer() {
  const { toast } = useToast();
  useEffect(() => {
    registerToastNotifier((message) => {
      toast({ title: 'Error', description: message, variant: 'error' });
    });
  }, [toast]);
  return null;
}

export function AppProviders({ children }: { children: React.ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider defaultThemeId="neue" persist storageKey="elva-theme-digital-marketing">
        <Toaster position="bottom-right">
          <ToastBridgeWirer />
          {children}
        </Toaster>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
